import { api } from '@/utils/client';
import router from '@/router';

const state = {
	index: {meta: {total: 0, last_page:1, current_page:1}, data:[]},
	detail: {type: ''},
	orders: {index:{meta: {total: 0, last_page:1, current_page:1}, data:[]}},
	request: {
		index: {meta: {total: 0, last_page:1, current_page:1}, data:[]},
		detail: {id: '', name: '', status: '', type: '', description: '', box_content: '', customisation: '', base_product: '', stock: '', product_id: '', team_id: '', created_at: ''},
	}
}

// actions
const actions = {
	async fetchProducts(context, params = {}) {
		try {
			if(params && params.page === 1){
				context.commit('fetchProducts', {data: [], meta: {total: 0}});
			}
			let response = await api.get('/teams/'+ (context.rootState.team.detail.plan=='pro' || router.history.current.path=='/dashboard' ? context.rootState.teamId : context.rootState.demo.teamId) +'/products', { params });
			context.commit('fetchProducts', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async fetchProduct(context, {productId, params = {}}) {
		try {
			let response = await api.get('/teams/'+ (context.rootState.team.detail.plan=='pro' || router.history.current.path=='/dashboard' ? context.rootState.teamId : context.rootState.demo.teamId) +'/product/'+ productId );
			if (!params.noCommit)
				context.commit('fetchProduct', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async updateProduct(context, {productId, payload}) {
		try {
			let response = await api.put('/teams/'+ context.rootState.teamId +'/product/'+ productId , payload);
			context.commit('fetchProduct', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async fetchProductOrders(context, {productId, page = 1, per_page = 10}) {
		try {
			let response = await api.get('/teams/'+ (context.rootState.team.detail.plan=='pro' || router.history.current.path=='/dashboard' ? context.rootState.teamId : context.rootState.demo.teamId) +'/product/'+ productId +'/orders', {params:{page: page, per_page: per_page}});
			context.commit('fetchProductOrders', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async fetchProductRequests(context, page = {}) {
		try {
			console.log(context.rootState.team.detail);
			let response = await api.get('/teams/'+ (context.rootState.team.detail.plan=='pro' || router.history.current.path=='/dashboard' ? context.rootState.teamId : context.rootState.demo.teamId) +'/products/requests', {params:page});
			context.commit('fetchProductRequests', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async fetchProductRequest(context, data) {
		try {
			let response = await api.get('/products/requests/' + data.requestId);
			context.commit('fetchProductRequest', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async createProductRequest(context, payload) {
		try {
			let response = await api.post('/teams/'+ context.rootState.teamId +'/products/requests', payload);
			context.commit('fetchProductRequest', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async updateProductRequest(context, {requestId, payload}) {
		try {
			let response = await api.put('/products/requests/' + requestId, payload);
			context.commit('fetchProductRequest', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async createRestockRequest(context, {productId, payload}) {
		try {
			let response = await api.post('/products/'+ productId +'/restock', payload);
			context.commit('fetchProductRequest', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async fetchMarketplacePhysicalProducts(context, params = {}) {
		try {
			if(params.page === 1){
				context.commit('fetchProducts', {data: [], meta: {total: 0}});
			}
			let response = await api.get('/marketplace/products/physical', { params });
			context.commit('fetchProducts', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async fetchMarketplaceDigitalProducts(context, params = {}) {
		try {
			if (params.page === 1) {
				context.commit('fetchProducts', {data: [], meta: {total: 0}});
			}
			let response = await api.get('/marketplace/products/digital', { params });
			context.commit('fetchProducts', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async fetchMarketplaceProduct(context, {productId}) {
		try {
			let response = await api.get('/products/'+ productId, {params:{platform:'marketplace'}});
			context.commit('fetchProduct', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async fetchMarketplaceDigitalProduct(context, voucherBrand) {
		try {
			let response = await api.get('/marketplace/products/digital/'+ voucherBrand);
			context.commit('fetchProduct', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
}
// mutations
const mutations = {
	// PRODUCTS
	// INDEX
	fetchProducts(state, data) {
		state.index = data;
	},
	fetchProduct(state, data) {
		state.detail = data;
	},
	fetchProductOrders(state, data) {
		state.orders.index = data;
	},
	// PRODUCT REQUESTS
	// INDEX
	fetchProductRequests(state, data) {
		state.request.index = data;
	},
	fetchProductRequest(state, data) {
		state.request.detail = data;
	},
}

export default {
	state,
	actions,
	mutations
}
